import { useParams } from 'react-router-dom';
// mantine
import { Button } from '@mantine/core';
// components
import { TSkill } from '@newo/api/gateway';
import Header from '@/components/Layout/components/Header/Header';
import ProjectBreadcrumb from '@/modules/Projects/components/ProjectBreadcrumb/ProjectBreadcrumb';
// utils
import { useCodeEditorState } from '@/pages/Library/Library.hooks';
import { PATHS } from '@/const';
import { useLibraryQuery } from '@/services/designer/libraries/libraries.queries';
import { useSaveSkillScriptMutation } from '@/pages/Library/Library.queries';

interface LibraryHeaderProps {
    skills: TSkill[];
    refetchSkills: () => void;
}

const LibraryHeader = ({ skills, refetchSkills }: LibraryHeaderProps) => {
    const { projectId, libraryId } = useParams();
    const { data: library } = useLibraryQuery(projectId, libraryId);
    const { hasUnsavedScripts } = useCodeEditorState(skills);
    const { mutate: saveSkillScripts } = useSaveSkillScriptMutation();

    const handleSave = () => {
        if (libraryId) {
            saveSkillScripts(
                { libraryId },
                {
                    onSuccess: () => {
                        refetchSkills();
                    }
                }
            );
        }
    };

    return (
        <Header
            breadcrumbs={[
                {
                    label: <ProjectBreadcrumb isLink projectId={projectId} />,
                    href: `${PATHS.projects}/${projectId}`
                },
                { label: library?.idn }
            ]}
        >
            <Button
                disabled={!hasUnsavedScripts}
                size="xs"
                onClick={handleSave}
            >
                Save
            </Button>
        </Header>
    );
};

export default LibraryHeader;
